var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_134_2105",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_134_2105)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2956 12.8335C17.1206 12.328 16.8533 11.8856 16.4936 11.5064C16.1338 11.1273 15.7012 10.8502 15.1956 10.6752V2.39185C17.9762 2.66407 20.3436 3.77726 22.2977 5.73143C24.2519 7.6856 25.3651 10.053 25.6373 12.8335H17.2956ZM12.8623 25.6085C9.86786 25.3168 7.36925 24.0627 5.36647 21.846C3.36369 19.6293 2.3623 17.0141 2.3623 14.0002C2.3623 10.9863 3.36369 8.37101 5.36647 6.15435C7.36925 3.93768 9.86786 2.68351 12.8623 2.39185V10.6752C12.1623 10.928 11.5984 11.3606 11.1706 11.9731C10.7429 12.5856 10.529 13.2613 10.529 14.0002C10.529 14.7391 10.7429 15.405 11.1706 15.9981C11.5984 16.5912 12.1623 17.0141 12.8623 17.2668V25.6085ZM15.1956 25.6085V17.2668C15.7012 17.0918 16.1338 16.8245 16.4936 16.4648C16.8533 16.105 17.1206 15.6724 17.2956 15.1668H25.6373C25.3651 17.9474 24.2519 20.3148 22.2977 22.2689C20.3436 24.2231 17.9762 25.3363 15.1956 25.6085Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dashIcon.78148122acb447ad9f1dc66f23d4628e.svg";
export { ForwardRef as ReactComponent };